import React from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PublicIcon from "@mui/icons-material/Public";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { GoStack } from "react-icons/go";
import { LuBook } from "react-icons/lu";
import { IoStatsChart } from "react-icons/io5";


const list = [
  {
    name: "Prices",
    icon: <GoStack className="w-6 h-auto" />,
    to: "items",
  },
  {
    name: "Collect",
    icon: <LuBook className="w-6 h-auto" />,
    to: "collections",
  },
  {
    name: "My Stats",
    icon: <IoStatsChart className="w-6 h-auto" />,
    to: "mystats/1",
  },
  {
    name: "MarketPlace",
    icon: <StorefrontIcon />,
    to: "marketplace",
  },
  {
    name: "Directory",
    icon: <PublicIcon />,
    to: "directory",
  },
];
const MenuBottom = ({ open }) => {
  return (
    <MenuBottomList open={open}>
      {list.map((item, index) => (
        <Box key={index} sx={{ textAlign: "center", lineHeight: "20px" }}>
          <Link to={`/${item.to}`}>
            <Box>{item.icon}</Box>
            <Typography variant="fontSize10">{item.name}</Typography>
          </Link>
        </Box>
      ))}
    </MenuBottomList>
  );
};

const MenuBottomList = styled(Box)(({ open }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  display: "flex",
  width: "100%",
  justifyContent: "space-around",
  boxShadow: "rgba(0, 0, 0, 0.25) 0px -2px 8px",
  padding: "8px",
  background: "#fff",
  zIndex: open && -2,
}));

export default MenuBottom;
